import { call, put, takeLatest, select } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import apiService from '../../api/service/apiService';
import ENDPOINTS from '../../api/endPoints';
import {
  fetchCampaignAnalyticsRequest,
  fetchCampaignAnalyticsSuccess,
  fetchCampaignAnalyticsFailure,
} from '../slices/campaignAnalyticsSlice';
import type { CampaignAnalyticsData } from '../slices/campaignAnalyticsSlice';
import type { RootState } from '../store';

/**
 * Fetch campaign analytics from API
 */
function* fetchCampaignAnalyticsSaga(
  action: PayloadAction<{ campaignPostId: string }>
): Generator<any, void, any> {
  try {
    const { campaignPostId } = action.payload;

    // Get restaurant ID from Redux state
    const restaurantId: string = yield select((state: RootState) => state.clover.restaurantId);

    // Call API using apiService with campaignPostId in URL path and restaurant-id header
    const response = yield call(apiService.get, {
      endpoint: `${ENDPOINTS.analytics}/${campaignPostId}`,
      headers: {
        'restaurant-id': restaurantId,
      },
    });

    // Extract data from response (API wraps data in a data property)
    const analyticsData: CampaignAnalyticsData = response.data?.data || response.data;

    // Dispatch success action
    yield put(fetchCampaignAnalyticsSuccess(analyticsData));
  } catch (error: any) {
    // Dispatch failure action
    const errorMessage = error?.message || 'Failed to fetch campaign analytics';
    yield put(fetchCampaignAnalyticsFailure(errorMessage));
    console.error('Campaign Analytics Saga Error:', error);
  }
}

/**
 * Watcher saga
 */
export default function* campaignAnalyticsSagaWatcher() {
  yield takeLatest(
    fetchCampaignAnalyticsRequest.type,
    fetchCampaignAnalyticsSaga
  );
}
